import { render, staticRenderFns } from "./CategoriesSelect.vue?vue&type=template&id=5bb04592&scoped=true&"
import script from "./CategoriesSelect.vue?vue&type=script&lang=js&"
export * from "./CategoriesSelect.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesSelect.vue?vue&type=style&index=0&id=5bb04592&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb04592",
  null
  
)

export default component.exports